import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { forwardRef } from 'react'
import { PROJECT_THEME } from '../../theme'

const LogoLink = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    color: ${({ theme }) => theme.colour.OFF_WHITE};
    text-decoration: none;
`

const LogoText = styled.span`
    color: ${({ theme }) => theme.colour.OFF_WHITE};
    font-family: ${({ theme }) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    font-weight: 900;
    text-transform: uppercase;
    font-size: 30px;
    line-height: 1;
    /* pulls the uppercase baseline down onto the cubes, cancelling the line box gap */
    margin-bottom: -4px;
`

const Image = styled.svg`
    height: 150px;
    width: 150px;
`

interface DetailedLogoProps{
    className?: string
}

const DetailedLogo = forwardRef<HTMLAnchorElement, DetailedLogoProps>(({className}, ref) => {
    return (
        <LogoLink to={''} ref={ref} className={className}>
            <LogoText>
                O'Neill
            </LogoText>
            <Image
                aria-label='a multi-coloured cube'
                role='img'
                viewBox='0 0 150 150'
                xmlns='http://www.w3.org/2000/svg'
            >
                <rect x='0' y='0' width='50' height='50' fill={PROJECT_THEME.colour.COLOUR_MID} />
                <rect x='50' y='0' width='50' height='50' fill={PROJECT_THEME.colour.COLOUR_MID_DARK} />
                <rect x='100' y='0' width='50' height='50' fill={PROJECT_THEME.colour.COLOUR_LIGHT} />

                <rect x='0' y='50' width='50' height='50' fill={PROJECT_THEME.colour.COLOUR_DARK} />
                <rect x='50' y='50' width='50' height='50' fill={PROJECT_THEME.colour.COLOUR_MID_LIGHT} />
                <rect x='100' y='50' width='50' height='50' fill={PROJECT_THEME.colour.COLOUR_MID} />

                <rect x='0' y='100' width='50' height='50' fill={PROJECT_THEME.colour.COLOUR_LIGHT} />
                <rect x='50' y='100' width='50' height='50' fill={PROJECT_THEME.colour.COLOUR_MID_DARK} />
                <rect x='100' y='100' width='50' height='50' fill={PROJECT_THEME.colour.COLOUR_DARK} />
            </Image>
        </LogoLink>
    )
})

export default DetailedLogo